<rb-loading-spinner *ngIf="dataLoadingSohTrajectories" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessageSohTrajectories && !dataLoadingSohTrajectories">
    <rb-callout type="warning">
        No data for "State of Health over mileage" chart.
    </rb-callout>
</div>
<div id="sohc-over-mileage-chart"></div>
<div class="p-2" *ngIf="!dataLoadingSohTrajectories && !errorMessageSohTrajectories">
    <div class="shaded-container ">
        Battery health over recent mileage and future prediction. Over time, battery health declines, potentially reducing vehicle range.
    </div>
</div>
